export default __webpack_public_path__ + "static/media/flag-suriname.ccef7702.svg";